import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=24c23cf7&scoped=true&"
import script from "./PromotionEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=24c23cf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c23cf7",
  null
  
)

export default component.exports